import { ImageLoaderConfig } from "@angular/common";
import { environment } from "src/environments/environment";

const myCustomLoader = (config: ImageLoaderConfig) => {
  // Example src: "12/responsive-images/43c89bd4b22c23a49488ed8340642f6f17906d2d___cover_1920_1200.webp"


  console.log("Config", config);
  if (!config.src) {
    return '';
  }

  return config.src + "?width=" + (config.width || 1080);
};

export {myCustomLoader};